import AccountModel                   from '@models/account/AccountModel';
import AccountSubscriptionStatusModel from '@models/account/AccountSubscriptionStatusModel';
import SubscriptionModel              from '@models/account/SubscriptionModel';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';
import AccountServiceModel            from '@/models/AccountServiceModel';
import TimestampAble                  from '@widesk-core/models/traits/TimestampAble';
import Blamable                       from '@/models/traits/Blamable';

@model.urnResource('account_subscription')
@doc.path('/account_subscriptions/{?id}')
export default class AccountSubscriptionModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'account': id;
		'accountSubscriptionConfigs': id;
		'accountSubscriptionStatus': id;
		'accountSubscriptionStatus.reference': Account_AccountSubscriptionStatusReference;
		'accountSubscriptionStatusHistories': id;
		'end[after]': string;
		'end[before]': string;
		'end[strictly_after]': string;
		'end[strictly_before]': string;
		'start[after]': string;
		'start[before]': string;
		'start[strictly_after]': string;
		'start[strictly_before]': string;
		'subscription': id;
	};

	private declare _tsSorts: {
		'account.name': string;
		'id': string;
		'subscription.label': string;
	};	

	@doc.model(AccountModel) declare account: AccountModel;
	@doc.model(AccountSubscriptionStatusModel) declare accountSubscriptionStatus: AccountSubscriptionStatusModel;
	@doc.date declare end: Dayjs;
	@doc.date declare start: Dayjs;
	@doc.model(SubscriptionModel) declare subscription: SubscriptionModel;
	}
